import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    RISKS_IN_UP_M1?: boolean;
    RISKS_IN_UP_WIP?: boolean;
    RISK_IN_UP_LIVE_TEST_DATA?: boolean;
    RISKS_IN_UP_M2?: boolean;
  }
}

export default {
  featureFlags: {
    // AWN-167523 Risks in Unified Portal
    RISKS_IN_UP_M1: true,
    RISKS_IN_UP_WIP: undefined,
    RISK_IN_UP_LIVE_TEST_DATA: undefined,
    RISKS_IN_UP_M2: undefined,
  },
} satisfies FeatureFlagConfig;
